import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { NavController, Platform } from '@ionic/angular';
import { LocaldataService } from '../../service/localdata/localdata.service';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { ConfigService } from '../../service/config/config.service';
import { AuthService } from '../../service/auth/auth.service';


@Component({
  selector: 'app-filelist',
  templateUrl: './filelist.component.html',
  styleUrls: ['./filelist.component.scss'],
})
export class FilelistComponent implements OnInit, OnDestroy {

  private folderId: any = 3766;
  private folderDepth:number = 1;

  private subscription: any; 

  constructor(private localData: LocaldataService, private route: ActivatedRoute, private router: Router, private iab: InAppBrowser, private config: ConfigService, private auth: AuthService, private platform: Platform) {


      /*this.route.queryParams.subscribe(params => {
        console.log(params);
      });*/
  

   }

   ngOnDestroy(){
    this.subscription.unsubscribe();
  }

  ngOnInit() {
    this.subscription = this.route.params.subscribe(params => {
      console.log('params',params);
      if(params.id){
        this.folderId = params.id
      }
      
    });
  }

  openTheFolder(obj){
    this.localData.breadcrumb.push({
      "id":obj.id,
      "displayName": obj.displayname
    });


    let navigationExtras: NavigationExtras = {
      queryParams: {
        special: JSON.stringify(123)
      }
    };console.log(obj.id)

    this.router.navigate(['dueslag', obj.id]) ;
    //this.navCtrl.navigateRoot
    //this.navCtrl.push(FolderPage, {folderId: obj.id, folderName: obj.displayname, breadcrumb: this.breadcrumb, folderDepth: this.folderDepth+1});
    //this.router.navigateByUrl(path);
  }

  openFile(obj){

    let baseUrl = this.config.basePath;
    let openUrl = baseUrl + '/api/' + obj.url + '&access_token=' + this.auth.currentToken;
    if(obj.ext != 'txt' && this.platform.is('android')){
      baseUrl = 'https://docs.google.com/gview?embedded=true&url=' + this.config.basePath;
      openUrl = baseUrl + '/api/' + encodeURIComponent(obj.url + '&access_token=' + this.auth.currentToken);
    }

    const browser = this.iab.create(openUrl);

    browser.show();

    if(!obj.read) {
      obj.read = true;    }

  }

}
